module.exports = __webpack_public_path__ + "static/media/add_icon.84f47a29.png";